import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import LatestSecurityInsights from "./sections/LatestSecurityInsights";
import BlogCategories from "./sections/BlogCategories";
import StartYourJourney from "./sections/StartYourJourney";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <LatestSecurityInsights />
      <BlogCategories />
      <StartYourJourney />
      <Footer />
    </div>;
}